import React, { useCallback } from "react";
import useFavoriteItemMutation from "hooks/useFavoriteItemMutation";
import CommonFavoriteIcon from "views/components/common/CommonFavoriteIcon";
const FavoriteIcon = ({ isFavorite, grn, onChange, className = void 0 }) => {
  const { putItem, deleteItem } = useFavoriteItemMutation();
  const onClick = useCallback(() => {
    if (isFavorite) {
      deleteItem(grn).then(() => onChange(false));
    } else {
      putItem(grn).then(() => onChange(true));
    }
  }, [isFavorite, deleteItem, grn, onChange, putItem]);
  const title = isFavorite ? "Remove from favorites" : "Add to favorites";
  return /* @__PURE__ */ React.createElement(CommonFavoriteIcon, { className, onClick, title, isFavorite });
};
export default FavoriteIcon;
